export default "__VITE_ASSET__9RHVqQDf__"